import React from 'react';
import { FMessage } from '../../hoc/IntlComponents';

const ContractStatus = ({ el_props, color }) => {
  if (el_props.status === 1) {
    return null;
  }

  return (
    <div className={`contracts-status-block ${color ? color : ''}`}>{el_props.status_message}</div>
  );
};

export default ContractStatus;
